<div class="main-container">
    <div>
        <div [formGroup]="paymentForm" *ngIf="paymentForm && paymentOrders.length > 0">
            <div class="payment-form-container">
                <div>
                    <p>
                        *Invoice
                    </p>
                    <p-dropdown dataKey="id" placeholder="SELECT" [options]="paymentOrders" optionLabel="label" formControlName="paymentOrder">
                    </p-dropdown>
                </div>
                <div>
                    <p>
                        *Date
                    </p>
                    <p-calendar dateFormat="dd/mm/yy" formControlName="date"></p-calendar>
                </div>
                <div>
                    <p>
                        *Amount
                    </p>
                    <input pInputText formControlName="amount" (change)="amountChange($event)">
                    <p class="global-warning"
                        *ngIf="paymentForm.get('amount')!.errors && paymentForm.get('amount')!.errors!['invalidCharacters']">
                        Wrong format</p>
                </div>
                <div>
                    <p>
                        *Currency
                    </p>
                    <p-dropdown [options]="currencyService.currencies" optionLabel="isoCode"
                        formControlName="currency" [style]="{'min-width':'70px'}">
                    </p-dropdown>
                </div>
                <div>
                    <p>
                        *Means of Payment
                    </p>
                    <p-dropdown [options]="bookingService.paymentTypes" optionLabel="name"
                        formControlName="paymentType">
                    </p-dropdown>
                </div>
                <div>
                    <p>
                        Comment
                    </p>
                    <input pInputText formControlName="comment">
                </div>
            </div>
        </div>
    </div>
    <div class="submit-button-container">
        <p-button label="Submit" (onClick)="submit()"></p-button>
    </div>
</div>